import { AxiosResponse } from 'axios';
import {
  IAdminNewsFeedListResponse,
  IAdminNewsFeedQueryParams,
  IAdminNewsFeedCommentsResponse,
  IAdminNewsFeedCommentsQueryParams,
  IAdminNewsFeedDeletePostResponse,
  IAdminNewsFeedDeleteCommentResponse,
} from '../../../interface/classveew-admin/news-feed.interface';
import { adminInstance } from '../../api';

export const adminNewsFeedService = {
  /**
   * Fetch all posts with pagination, search, and status filter.
   * Backend endpoint: POST /v2/admin/posts
   * The adminInstance baseURL already includes /admin prefix.
   */
  fetchPosts: async (
    params: IAdminNewsFeedQueryParams,
  ): Promise<AxiosResponse<IAdminNewsFeedListResponse>> => {
    const response = await adminInstance.post('/posts', params);
    return response;
  },

  /**
   * Fetch paginated comments for a specific post.
   * Backend endpoint: GET /v2/admin/posts/:postId/comments?page=&pageSize=
   */
  fetchComments: async (
    postId: string,
    params?: IAdminNewsFeedCommentsQueryParams,
  ): Promise<AxiosResponse<IAdminNewsFeedCommentsResponse>> => {
    const response = await adminInstance.get(`/posts/${postId}/comments`, {
      params,
    });
    return response;
  },

  /**
   * Soft-delete a post.
   * Backend endpoint: DELETE /v2/admin/posts/:postId
   */
  deletePost: async (postId: string): Promise<AxiosResponse<IAdminNewsFeedDeletePostResponse>> => {
    const response = await adminInstance.delete(`/posts/${postId}`);
    return response;
  },

  /**
   * Soft-delete a comment under a specific post.
   * Backend endpoint: DELETE /v2/admin/posts/:postId/comments/:commentId
   */
  deleteComment: async (
    postId: string,
    commentId: string,
  ): Promise<AxiosResponse<IAdminNewsFeedDeleteCommentResponse>> => {
    const response = await adminInstance.delete(`/posts/${postId}/comments/${commentId}`);
    return response;
  },
};
